import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Filter } from 'react-bootstrap-icons';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@mui/styles/styled';
import { renderablePropType } from '../../utils/propTypes';
import DrawerButton from '../DrawerButton';
import DrawerBody from '../DrawerBody';
import DrawerFooter from '../DrawerFooter';
import DrawerHeader from '../DrawerHeader';
import ResetButton from '../DrawerButton/ResetButton';
import Section from '../DrawerButton/Section';
import SectionBody from '../DrawerButton/SectionBody';
import SectionHeader from '../DrawerButton/SectionHeader';
import Sections from '../DrawerButton/Sections';

const InputContainer = styled('div')(({ theme }) => ({
	margin: `${theme.spacing(2)}px 0`,
}));

function FiltersDrawer({
	title,
	onReset = () => {},
	onApply,
	onOpen = () => {},
	onClose = () => {},
	children,
	ButtonProps = {},
	DrawerProps = {},
	openRef = () => {},
	dataTestid,
}) {
	const [isOpen, setIsOpen] = useState(false);
	openRef([isOpen, setIsOpen]);
	const { t } = useTranslation('common');

	return (
		<DrawerButton
			startIcon={
				<Filter
					role="graphics-symbol"
					aria-hidden="true"
					aria-label="Filter Circle"
				/>
			}
			buttonText={title || t('filters')}
			onOpen={(...args) => {
				setIsOpen(true);
				onOpen(...args);
			}}
			onClose={(...args) => {
				setIsOpen(false);
				onClose(...args);
			}}
			isOpen={isOpen}
			ButtonProps={{
				'data-testid': dataTestid || 'table_filter',
				...ButtonProps,
			}}
			DrawerProps={DrawerProps}
		>
			<DrawerHeader onClose={() => setIsOpen(false)}>
				<ResetButton
					onClick={onReset}
					role="button"
					aria-label={t('reset_filters')}
					data-testid="reset_orders_table_columns"
				>
					{t('reset_filters')}
				</ResetButton>
			</DrawerHeader>

			<DrawerBody>
				{typeof children === 'function'
					? children({
							SectionHeader,
							SectionBody,
							Section,
							Sections,
							InputContainer,
					  })
					: children}
			</DrawerBody>

			<DrawerFooter divider>
				<Button
					variant="contained"
					color="primary"
					size="large"
					fullWidth
					role="button"
					data-testid={t('apply')}
					aria-label={t('apply')}
					onClick={(...args) => {
						setIsOpen(false);
						onApply(...args);
					}}
				>
					{t('apply')}
				</Button>
			</DrawerFooter>
		</DrawerButton>
	);
}

FiltersDrawer.propTypes = {
	title: renderablePropType,
	onReset: PropTypes.func,
	onApply: PropTypes.func.isRequired,
	onOpen: PropTypes.func,
	onClose: PropTypes.func,
	children: renderablePropType,
	ButtonProps: PropTypes.object,
	DrawerProps: PropTypes.object,
	openRef: PropTypes.func,
	dataTestid: PropTypes.string,
};

export default FiltersDrawer;
